import firebase from "firebase";
import axios from "axios";
import {storage} from "../firebase";

//Updates view count on student page
export function UserVisitedPage() {
    console.log('called')
    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            let studentEntry = {
                user: user.email.split('@')[0],
                pronunciation: 0,
                dialogConversation: 0,
                translation: 0,
                dialogFlashCard: 0,
                quizzes: 0
            };
            let userName = user.email.split('@')[0];
            if (userName === 'uhadmin') {
                return;
            }
            let studentData;
            let found = false;

            //retrieve the student data file
            const studentFile = firebase.storage().ref().child('students/studentData.json');
            studentFile.getDownloadURL()
                .then(async url =>  await axios.get(url))
                .then(res => {

                    studentData = res.data;
                    for (let i = 0; i < studentData.length; i++) {
                        if (userName === studentData[i].user) {
                            found = true;
                            break;
                        }
                    }
                    for (let i = 0; i < studentData.length; i++) {
                        if (userName === studentData[i].user) {

                            //window.location.pathname returns the pathname for the page then switch statement increments student data
                            switch (window.location.pathname) {
                                case '/pronunciation':
                                    studentData[i].pronunciation += 1;
                                    break;
                                case '/dialogConversation':
                                    studentData[i].dialogConversation += 1;
                                    break;
                                case '/translation':
                                    studentData[i].translation += 1;
                                    break;
                                case '/dialogFlashCard':
                                    studentData[i].dialogFlashCard += 1;
                                    break;
                                case '/quizzes':
                                    studentData[i].quizzes += 1;
                                    break;
                                default:
                                    break;
                            }
                        }
                        if (!found) {
                            studentData.push(studentEntry);
                        }

                    }

                    const JSONobj = JSON.stringify(studentData);
                    const blobObj = new Blob([JSONobj], {type: "application/json"});
                    const uploadTask = storage.ref('students/studentData.json').put(blobObj);
                    uploadTask.on(
                        "state_changed",
                        () => {
                        },
                        error => {
                            console.log(error)
                        },
                        () => {
                            storage
                                .ref("students")
                                .child('studentData.json')
                                .getDownloadURL()
                                .then(url => {
                                        console.log(url);
                                    }
                                )
                                .catch(e => console.log(e));
                        }
                    )
                });


        }
    })
}
